import { Base, Button, useTranslation } from 'zf-web-components';
import { useRouteError } from 'react-router';
import { CONFIG } from 'config';
import styles from './style.module.less';
import type { ReactElement } from 'react';

export function RouteException(): ReactElement | null {
  const [t] = useTranslation();
  const error = useRouteError() as Error;

  return (
    <main className={styles.exception}>
      <Base.Row>
        <Base.Col span={6} offset={6}>
          <img className={styles.errorImg} src={`${CONFIG.IMAGE_STATIC}/thinking.svg`} />
        </Base.Col>
        <Base.Col className={styles.error} span={6}>
          <p className={styles.errorMessage}>{error.message}</p>
          <Base.Space>
            <Button type='primary'
              icon='RollbackOutlined'
              label={t('返回')}
              onClick={() => window.location.assign('/')} />
            <Button type='primary'
              icon='SwapOutlined'
              label={t('重试（刷新）')}
              onClick={() => window.location.reload()} />
          </Base.Space>
        </Base.Col>
      </Base.Row>
    </main>
  );
}
